import React from 'react';

import { useSelector } from 'react-redux';

import { selectCloudRecordingStatus } from '../../../../features/cloud-recording';
import { StartCloudRecordingOption } from './start-cloud-recording-option';
import { StopCloudRecordingOption } from './stop-cloud-recording-option';
import { WaitingCloudRecordingOption } from './waiting-cloud-recording-option';

export function CloudRecordingOption() {
    const cloudRecordingStatus = useSelector(selectCloudRecordingStatus);
    if (cloudRecordingStatus === 'TURNED_OFF' || !cloudRecordingStatus) {
        return <StartCloudRecordingOption />;
    }

    if (cloudRecordingStatus === 'STARTING') {
        return <WaitingCloudRecordingOption />;
    }

    return <StopCloudRecordingOption />;
}
